import {
  TEntityResponse,
  TEntityListResponse,
  TCreateContactReqBody,
  TContactResBody,
  TContactSummaryResBody,
  TUpdateContactReqBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TContactsClient = {
  create(body: TCreateContactReqBody): Promise<TEntityResponse<'contact', TContactResBody> | undefined>;
  update(id: string, body: TUpdateContactReqBody): Promise<TEntityResponse<'contact', TContactResBody> | undefined>;
  delete(id: string): Promise<void>;
  get(id: string): Promise<TEntityResponse<'contact', TContactResBody> | undefined>;
  list(filterByCompanyId: string): Promise<TEntityListResponse<'contact', TContactSummaryResBody> | undefined>;
};

function ContactsClient(apiClient: TAPIClient): TContactsClient {
  return {
    async create(body: TCreateContactReqBody): Promise<TEntityResponse<'contact', TContactResBody> | undefined> {
      const data = await apiClient.post<TCreateContactReqBody, TEntityResponse<'contact', TContactResBody>>(
        `/contacts`,
        body
      );

      if (data && data.type !== 'contact') {
        throw new Error('Invalid entity type received, expected: contact, received: ' + data.type);
      }

      return data;
    },

    async update(
      id: string,
      body: TUpdateContactReqBody
    ): Promise<TEntityResponse<'contact', TContactResBody> | undefined> {
      const data = await apiClient.put<TUpdateContactReqBody, TEntityResponse<'contact', TContactResBody>>(
        `/contacts/${id}`,
        body
      );

      if (data && data.type !== 'contact') {
        throw new Error('Invalid entity type received, expected: contact, received: ' + data.type);
      }

      return data;
    },

    async delete(id: string): Promise<void> {
      return await apiClient.delete(`/contacts/${id}`);
    },

    async get(id: string): Promise<TEntityResponse<'contact', TContactResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'contact', TContactResBody>>(`/contacts/${id}`);

      if (data && data.type !== 'contact') {
        throw new Error('Invalid entity type received, expected: contact, received: ' + data.type);
      }

      return data;
    },

    async list(filterByCompanyId: string): Promise<TEntityListResponse<'contact', TContactSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'contact', TContactSummaryResBody>>(
        `/contacts?${filterByCompanyId}`
      );

      if (data && data.type !== 'contact') {
        throw new Error('Invalid entity type received, expected: contact, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TContactsClient, ContactsClient };
